import { useAuthInfiniteList } from 'queries/query';
import { getQueryKeys } from 'queries/query-key';
import { AdminsApi } from 'api';
import { IAdmin, SearchAdminFilterType } from 'types';
import { KEY } from './keys';

function useGetInfinite(filter: SearchAdminFilterType, size = 30) {
  return useAuthInfiniteList<IAdmin>(
    [...getQueryKeys([KEY]).lists(), 'infinite', { ...filter, size }],
    (page) => AdminsApi.getAll({ ...filter, page, size }),
  );
}

export default useGetInfinite;
